import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FooterTop from "../component/FooterTop";

function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}
export default function Visaservices() {

  const [visaServices, setVisaServices] = useState([]);
 
  useEffect(() => {
    fetch('https://goforen.com/go_foren/get_visa_services/')
      .then((res) => res.json())
      .then((data) => {
        setVisaServices(data);
      })
      .catch((err) => console.error("Failed to fetch visa services:", err));
  }, []);

  const [background, setBackground] = useState("");

  useEffect(() => {
    const backgroundUrl ="/assets/pic/breadcrumb-bg.jpg";
    setBackground(backgroundUrl);
  }, []);
      const [background12, setBackground12] = useState("");
        
          useEffect(() => {
            const backgroundUrl12 = "assets/img/bg/blog_bg.png";
            setBackground12(backgroundUrl12);
          }, []);
  // data-background img end
  return (
    <div>
      <Navbar />

      {/* <!-- breadcrumb start --> */}
      <section
  className="breadcrumb pos-rel bg_img"
  style={{ 
    backgroundImage: `url(${background})`, 
    minHeight: '400px',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
  {/* Overlay */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // black overlay with 50% opacity
    zIndex: 1
  }}></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="breadcrumb__content">
    <h2 className="breadcrumb__title" style={{color:'#fff'}}>Visa Services</h2>
            <ul className="breadcrumb__list clearfix">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item">Visa Services</li>
      </ul>
    </div>
  </div>
   
        {/* <div className="breadcrumb__circle">
          <span
            className="big"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
          <span
            className="small"
            data-parallax='{"y" : 100, "scale" : 0.1}'
          ></span>
        </div>
        <div className="breadcrumb__shape">
          <div className="shape shape--1">
            <div className="shape-inner" data-parallax='{"x":-50,"y":80}'>
              <img src="assets/img/shape/br_shape1.png" alt="" />
            </div>
          </div>
          <div className="shape shape--2">
            <div className="shape-inner" data-parallax='{"x":50,"y":-90}'>
              <img src="assets/img/shape/br_shape2.png" alt="" />
            </div>
          </div>
        </div> */}
      </section>
      {/* <!-- breadcrumb end --> */}
      {/* What is a visa start  */}
      <section className="about pos-rel  pt-120">
        <div className="container">
        <div className="sec-title sec-title--big style-2 mb-20">
                <h3 style={{marginBottom:'20px'}}>   Our Visa & Immigration Services</h3>
                <p>
              At GO FOREN, we provide end-to-end visa and immigration support for individuals, families, professionals, and students. Our expertise covers five major areas – Work Permits & Visas, Student Admissions & Visas, Permanent Residency (PR) Visas, Travel/Tourist Visas, and Investor/Business Visas.
                </p>
                <p>
            We believe that going abroad is not just about paperwork – it is about fulfilling dreams, securing opportunities, and building a better future.
                </p>
              </div>
         
  
              <div className="sec-title sec-title--big style-2 mb-20">
                <h3 style={{marginBottom:'20px'}}>    What is a visa?</h3>
                <p>
                A visa is an official document issued by a country’s immigration authority. It is usually stamped or affixed to your passport and gives you permission to travel to that country for a specific purpose and period.
                </p>
                <p>
                  Holding a visa does not guarantee entry — the Immigration Officer at the port of entry has the final say on whether you can enter and how long you can stay. In simple words, a visa is proof that your credentials have been checked and you have been allowed to travel.
                </p>
              </div>
         
        
          <div className="sec-title sec-title--big style-2 mb-20">
           <h3 style={{marginBottom:'20px'}}> Types of Visas We Handle</h3>
      <h3 style={{marginBottom:'20px'}}> 1. Work Permit & Work Visas</h3>

            <p style={{ paddingBottom: "10px" }}>
             A <b>work visa </b>allows you to take up employment abroad. Its duration often matches your job contract and may extend up to five years. This is ideal for skilled professionals, technical workers, and individuals with job offers abroad. Permanent Residency visas are also linked to this category as they grant the right to live and work permanently.
            </p>
                <h3 style={{marginBottom:'20px'}}> Our role:</h3>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}>  Job search support and employer connections.  </li>
               <li style={{ textAlign: "justify" }}>  Interview preparation and offer letter finalization .</li>
                <li style={{ textAlign: "justify" }}> 	Filing of work permit application and compliance.  </li>
            </ul>
          

           <h3 style={{marginBottom:'20px'}}>2. Student Admissions & Student Visas</h3>

            <p style={{ paddingBottom: "10px" }}>
             A <b>student visa  </b>enables you to study abroad at colleges, universities, or training institutes. These visas allow you to stay for the length of your course and, in many countries, extend for a short duration after completion.
            </p>
                <h3 style={{marginBottom:'20px'}}> Our role:</h3>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}>  	Profile assessment and course/college selection. </li>
               <li style={{ textAlign: "justify" }}> 	Admission application and offer letter assistance.</li>
                <li style={{ textAlign: "justify" }}> 	Proof of funds and visa application filing.  </li>
            </ul>

              <h3 style={{marginBottom:'20px'}}>3. Permanent Residency (PR) Applications</h3>

            <p style={{ paddingBottom: "10px" }}>
             A <b>Permanent Residency  visa  </b> grants you the right to live in another country for an indefinite period without being its citizen. Permanent residents often enjoy work rights, health care, and other benefits.
            </p>
                <h3 style={{marginBottom:'20px'}}> Our role:</h3>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}>  		Eligibility check for PR programs. </li>
               <li style={{ textAlign: "justify" }}> 		Documentation and application filing.</li>
                <li style={{ textAlign: "justify" }}> 		Guidance for settlement and compliance after approval.  </li>
            </ul>

              <h3 style={{marginBottom:'20px'}}>4. Travel & Temporary Resident Visas</h3>

            <p style={{ paddingBottom: "10px" }}>
             A <b>Temporary visas  </b>are for short stays such as holidays, family visits, or transit. Common examples include:

            </p>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>Tourist visa - </b> travel for leisure and sightseeing.</li>
               <li style={{ textAlign: "justify" }}>  <b>	Transit visa - </b> pass through another country en route to your destination.</li>
                <li style={{ textAlign: "justify" }}>  <b>	Spousal visa - </b> 	 join your spouse living abroad.  </li>
            </ul>
                <h3 style={{marginBottom:'20px'}}> Our role:</h3>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}>  	Application preparation</li>
               <li style={{ textAlign: "justify" }}> 	Supporting documents review</li>
                <li style={{ textAlign: "justify" }}> 		Embassy submission and follow-up  </li>
            </ul>

             <h3 style={{marginBottom:'20px'}}>5. Business & Investor Visas</h3>

            <p style={{ paddingBottom: "10px" }}>
           Business visas allow professionals to attend meetings, conferences, or explore business opportunities abroad. Investor and entrepreneur visas open doors for global business expansion and investment opportunities.
            </p>
                <h3 style={{marginBottom:'20px'}}> Our role:</h3>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}>  		Identifying the right investor/entrepreneur program </li>
               <li style={{ textAlign: "justify" }}> Preparing business documents and financial proofs</li>
                <li style={{ textAlign: "justify" }}> 		Filing application and embassy submission  </li>
            </ul>

          
              <h3 style={{marginBottom:'20px'}}>Documents Generally Required</h3>

            <p style={{ paddingBottom: "10px" }}>
             Requirements vary by visa type, but common documents include:

            </p>
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>	Personal ID  - </b>Passport, birth certificate, national ID</li>
               <li style={{ textAlign: "justify" }}>  <b>		Education Records  - </b>Mark sheets, transcripts, and certificates</li>
                <li style={{ textAlign: "justify" }}>  <b>		Work Experience  - </b> 	Appointment letters, salary slips, experience letters</li>
                     <li style={{ textAlign: "justify" }}> <b>Financial Proofs - </b>IT returns, bank statements, fixed deposits, CA certificates</li>
               <li style={{ textAlign: "justify" }}>  <b>			Relative Abroad   - </b>Proof of relationship and their legal stay documents</li>
                <li style={{ textAlign: "justify" }}>  <b>	Language Test Results  - </b> 	IELTS, TOEFL, PTE, or others</li>
            </ul>
            
                          <h3 style={{marginBottom:'20px'}}>Our Process – How GO FOREN Supports You</h3>
                          <p style={{ paddingBottom: "10px" }}>
           We handle your journey step by step to ensure smooth processing and success.

            </p>
               <h3 style={{marginBottom:'20px'}}>Step 1 – Initial Consultation & Eligibility Check</h3>
                          <p style={{ paddingBottom: "10px" }}>
          We understand your goals, check eligibility, and suggest the most suitable visa option.

            </p>
               <h3 style={{marginBottom:'20px'}}>Step 2 – Registration, Agreement & Documentation Support</h3>
                          <p style={{ paddingBottom: "10px" }}>
          Once you register with us, we guide you in collecting and preparing all necessary documents.

            </p>

                   <h3 style={{marginBottom:'20px'}}>Step 3 – Profile Enhancement</h3>
                          <p style={{ paddingBottom: "10px" }}>
          We design international standard CVs and cover letters tailored to your chosen visa pathway.

            </p>







             <h3 style={{marginBottom:'20px'}}>Step 4 – Job Search or Course Selection</h3>

    
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>		Work Visa Pathway –  </b>We help with job applications, employer connections, and interview preparation.</li>
               <li style={{ textAlign: "justify" }}>  <b>			Student Visa Pathway  - </b>We assist in selecting universities, courses, and destinations suited to your profile.</li>
            </ul>

                 <h3 style={{marginBottom:'20px'}}>Step 5 – Offer Confirmation</h3>

    
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>			For Professionals  - </b>Finalizing your job offer and contract.</li>
               <li style={{ textAlign: "justify" }}>  <b>		For Students   - </b>Receiving admission confirmation and paying tuition deposits.</li>
            </ul>
                 <h3 style={{marginBottom:'20px'}}>Step 6 – Application Filing</h3>

    
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>		Work Permits  –  </b>Submitting applications, handling compliance, and legalization.</li>
               <li style={{ textAlign: "justify" }}>  <b>		Student Visas  - </b>Preparing proof of funds, medicals, and academic readiness..</li>
            </ul>


               <h3 style={{marginBottom:'20px'}}>Step 7 – Visa Application & Embassy Submission</h3>
                          <p style={{ paddingBottom: "10px" }}>
         We prepare your visa file, arrange financial proofs, submit to Embassy/VFS, and track the progress.

            </p>
               <h3 style={{marginBottom:'20px'}}>Step 8 – Decision, Passport Stamping & Post-Arrival Support</h3>
                          <p style={{ paddingBottom: "10px" }}>
          Once approved, we guide you with passport stamping, travel planning, and settlement support in your new country.

            </p>
            
            
             <h3 style={{marginBottom:'20px'}}>Why Choose GO FOREN?</h3>

    
            <ul style={{ paddingBottom: "10px", paddingLeft: "15px" }}>
              <li style={{ textAlign: "justify" }}> <b>		Comprehensive Services –  </b>From first consultation to post-arrival assistance.</li>
               <li style={{ textAlign: "justify" }}>  <b>			Professional Guidance  - </b>Expertise in five major visa categories.</li>
                 <li style={{ textAlign: "justify" }}> <b>		Personalized Approach  –  </b>– Solutions tailored to your goals, background, and budget.</li>
               <li style={{ textAlign: "justify" }}>  <b>			Global Standards   - </b>CVs, cover letters, and applications designed for international acceptance.</li>
                 <li style={{ textAlign: "justify" }}> <b>		Trust & Transparency –  </b>Clear communication, step-by-step support, and client-first focus.</li>
 
            </ul>

<h3 style={{marginBottom:'20px'}}>Conclusion</h3>
                          <p style={{ paddingBottom: "10px" }}>
   A visa is the gateway to your international journey – whether it is <b>studying abroad, building a global career, joining family, investing in opportunities, or exploring the world.</b>

            </p>
                         <p style={{ paddingBottom: "10px" }}>
 At<b>GO FOREN, </b>we simplify this journey for you. With structured processes, expert guidance, and full support at every stage, we help turn your dream of going abroad into a reality.

            </p>
            <h3 style={{marginBottom:'20px'}}>GO FOREN – From Ambition to Achievement.</h3>
          </div>
        </div>
        <div className="about-shape">
          <div className="shape shape--1">
            <div className="shape-inner" data-parallax='{"x":-50,"y":-80}'>
              <img src="assets/img/shape/a_shape1.png" alt="" />
            </div>
          </div>
          <div className="shape shape--2" style={{ top: "70%", right: "7%" }}>
            <div className="shape-inner" data-parallax='{"x":50,"y":-80}'>
              <img src="assets/img/shape/a_shape2.png" alt="" />
            </div>
          </div>
        </div>

        
              {/* <!-- visa type start --> */}
              <section className="visa-type pt-120 pb-135">
            {/* <div className="container"> */}
                <div className="sec-title text-center mb-60">
                    <h2 className="wow skewIn">Visa Services </h2> <br />
                  <p style={{justifyContent:'center',display:'flex',marginTop:'15px'}}>"Comprehensive visa services to simplify your journey abroad, from application to approval."</p>
                </div>
{/* <div className="row justify-content-md-center mt-none-30">
  {visaServices.map((item) => (
    <div key={item.id} className="col-lg-4 col-md-6 mt-30">
      <a href={`/visa-services-detail?id=${item.id}`}>
        <div className="xb-service">
          <div className="xb-item--inner">
            <div className="xb-item--icon mb-50">
              <img
                src={`https://lh3.googleusercontent.com/d/${item.image_id}`}
                alt={item.visa_type}
                className="img-fluid"
              />
            </div>
            <div className="xb-item--holder">
              <h3 className="xb-item--title mb-20">
                {item.visa_type}
              </h3>
              <div className="xb-item--description">
                {item.description
                  ? item.description.replace(/<[^>]+>/g, '').slice(0, 50) + '...'
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  ))}
</div> */}
<div className="px-5">
          <div className="row align-items-center">
            <div className="col-lg-10">
              <div className="about__content">
       <ul className="about-list ul_li list-unstyled">
                    {visaServices.map((service, index) => (
    <li key={service.id}>
      <a href={`/visa-services-detail?id=${service.id}`}>
        <div className="xb-item--inner" style={{
        backgroundImage: 'linear-gradient(135deg, rgba(214, 131, 48, 0.4), rgba(158, 63, 63, 0))',
        padding: '35px 20px',
        borderRadius: '10px'
      }}>
          <div className={`xb-item--number color-${(index % 5) + 1}`}>
            {index + 1}
          </div>
          <div className="xb-item--holder">
            <h3 className="xb-item--title mb-10">{service.visa_type}</h3>
            <p style={{ color: '#787B84' }}>
              {/* Optional: Show a trimmed version of the description */}
              {stripHtml(service.description).slice(0, 80)}...
            </p>
          </div>
        </div>
      </a>
    </li>
  ))}
</ul>

              </div>
            </div>
          </div>
</div>
        </section>
        {/* <!-- visa type end --> */}
      </section>

      {/* What is a visa end  */}
  {/* working time  */}
  <div style={{background:'#edf3f5',padding:'30px 0px'}}>
  <div className="container">
        <div
          className="xb-newsletter1 pos-rel "
          style={{
            backgroundImage: `url(${background12})`,
            // minHeight: '400px',
            position: "relative",
            backgroundSize: "cover",
            backgroundPosition: "center",
            margin: "30px 0px",
          }}
        >
          <div className="row">
            <div className="col-12">
              <div>
                <div className="sec-title mb-40 text-center">
                  <h2 className="mb-20 wow skewIn">Our Working Time</h2>
                  <p style={{ textAlign: "center" }}>
                    We are available throughout the week to help you with your
                    visa and training needs.
                  </p>
                </div>

                <div className="row justify-content-center text-center">
                  <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: " 0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <div>
                      <h5 className="mb-2">Monday - Saturday :</h5>
                      <p style={{ textAlign: "center" }}>
                        10.00 a.m. to 6.30 p.m.
                      </p>
                    </div>
                  </div>
                  {/* <div
                    className="col-lg-3 mt-30 col-md-6"
                    style={{
                      boxShadow: "0px 14px 19px rgb(221 229 236)",
                      padding: "20px",
                      margin: "5px",
                    }}
                  >
                    <h5 className="mb-2">Sunday :</h5>
                    <p style={{ textAlign: "center" }}>
                      10.00 a.m. to 12.30 p.m.
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      {/* workingtime end  */}

      <Footer />
    </div>
  );
}
